import React from "react";
import { useTranslation } from "react-i18next";
import { StepFlowStep } from "../../../components/misc/StepFlow";

interface IntroductionViewProps {
  setStep: (step: 1 | -1) => void;
  dashboardType: "community" | "business";
}

export default function IntroductionView({ setStep, dashboardType }: IntroductionViewProps) {
  const { t } = useTranslation();
  return (
    <StepFlowStep setStep={setStep} showPrev={false} className="max-w-4xl">
      <div className="mx-auto my-auto flex h-full w-full flex-col items-center justify-center gap-2 md:flex-row">
        <img
          alt="Vera Phone"
          src={`${process.env.PUBLIC_URL}/assets/figures/phone_hi.svg`}
          className="w-[50%]"
        />
        <div className="flex w-full flex-col gap-1">
          <h1 className="text-3xl font-semibold">{t('page.onboarding.introduction.title')}</h1>
          <p> {t('page.onboarding.introduction.subtitle')}</p>
        </div>
      </div>
    </StepFlowStep>
  );
}